export type PostCaseOutcome = "win" | "loss";

export const POST_CASE_WIN_MSG =
  "The judge signed the warrant. The killer was arrested!";
export const POST_CASE_LOSS_MSG =
  "Warrant denied, and the killer fled town! Care to investigate another case?";

export function hubOutcomeBannerHtml(outcome: PostCaseOutcome): string {
  const win = outcome === "win";
  const cls = win ? "hub-outcome-win" : "hub-outcome-loss";
  const text = win ? POST_CASE_WIN_MSG : POST_CASE_LOSS_MSG;
  return `<p class="hub-outcome-banner ${cls}" role="status">${text}</p>`;
}
